export async function fetchDealExport(uid, signal) {
    const response = await fetch(`/api/exports/deals/${encodeURIComponent(uid)}`, {
        method: "GET",
        credentials: "same-origin",
        cache: "no-store",
        headers: {
            Accept: "application/json",
        },
        signal,
    });

    if (!response.ok) {
        let message = `Erreur HTTP ${response.status}`;

        try {
            const payload = await response.json();
            message = payload?.error || message;
        } catch (_) {
            // La réponse n'est pas du JSON : on conserve le message HTTP.
        }

        throw new Error(message);
    }

    return response.json();
}

export async function updateDealClassifiedTitle(uid, classifiedTitle) {
    const response = await fetch(`/api/exports/deals/${encodeURIComponent(uid)}/classified-title`, {
        method: "PATCH",
        credentials: "same-origin",
        cache: "no-store",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ classified_title: classifiedTitle }),
    });

    if (!response.ok) {
        let message = `Erreur HTTP ${response.status}`;

        try {
            const payload = await response.json();
            message = payload?.error || message;
        } catch (_) {
            // Réponse non JSON : conserver le message HTTP.
        }

        throw new Error(message);
    }

    return response.json();
}
